/**
 * Guards portal routes — redirects to /portal/startup/login if no session.
 */
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useStartupPortalAuth } from "@/contexts/StartupPortalAuthContext";

export default function RequireStartupSession() {
  const { phase } = useStartupPortalAuth();
  const location = useLocation();

  if (phase === "checking") {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-porcelain text-warmGrey"
        data-testid="portal-checking"
      >
        <p className="text-sm">Lade …</p>
      </div>
    );
  }
  if (phase !== "authenticated") {
    return (
      <Navigate
        to="/portal/startup/login"
        state={{ from: location.pathname + location.search }}
        replace
      />
    );
  }
  return <Outlet />;
}
